export default __webpack_public_path__ + "static/media/trackingRecordPayment.ba0e3662.png";